<template>
  <p class="my-0">
    <template v-for="(part, index) in parsedMessageParts">
      <span v-if="part.type === 'text'" :key="`text-${messageItem.id}-${index}`">{{ part.value }}</span>
      <button
        v-else
        :key="`link-${messageItem.id}-${index}`"
        type="button"
        class="overview-message-radiograph-link-button"
        @click="downloadRadiograph(part.radiographId)">
        {{ part.value }}
      </button>
    </template>
  </p>
</template>

<script>
  import methods from '../../utils/methods';
  import api from '../../api/api';

  export default {
    name: 'OverviewMessageText',

    props: {
      messageItem: {
        type: Object,
        required: true,
      },
      visitId: {
        type: Number,
        required: true,
      },
    },

    computed: {
      parsedMessageParts: function () {
        let text = (this.messageItem && this.messageItem.text) || '';
        let rontgenTextRegex = /\[\s*Rontgen uploaded:\s*([^\]]*)\]/i;
        let match = text.match(rontgenTextRegex);

        if (!match || typeof match.index !== 'number') {
          return [{
            type: 'text',
            value: text,
          }];
        }

        let beforeText = text.substring(0, match.index);
        let afterText = text.substring(match.index + match[0].length);
        let radiographNames = match[1]
          .split(',')
          .map((name) => name.trim())
          .filter((name) => name.length > 0);
        let radiographs = (this.messageItem && this.messageItem.radiographs) || [];
        let usedRadiographIndexes = [];
        let parts = [];

        if (beforeText.length > 0) {
          parts.push({
            type: 'text',
            value: beforeText,
          });
        }

        parts.push({
          type: 'text',
          value: '[ Rontgen uploaded: ',
        });

        radiographNames.forEach((name, index) => {
          let normalizedName = name.toLowerCase();
          let radiographIndex = radiographs.findIndex((radiographItem, itemIndex) => {
            if (usedRadiographIndexes.includes(itemIndex)) return false;
            if (!radiographItem || !radiographItem.fileName || !radiographItem.id) return false;
            return radiographItem.fileName.trim().toLowerCase() === normalizedName;
          });

          if (radiographIndex >= 0) {
            usedRadiographIndexes.push(radiographIndex);
            parts.push({
              type: 'link',
              value: name,
              radiographId: radiographs[radiographIndex].id,
            });
          } else {
            parts.push({
              type: 'text',
              value: name,
            });
          }

          if (index < radiographNames.length - 1) {
            parts.push({
              type: 'text',
              value: ', ',
            });
          }
        });

        parts.push({
          type: 'text',
          value: ' ]',
        });

        if (afterText.length > 0) {
          parts.push({
            type: 'text',
            value: afterText,
          });
        }

        return parts;
      },
    },

    methods: {
      downloadRadiograph: function (radiographId) {
        methods.downloadURL(api.radiographFileUrl(this.visitId, radiographId));
      },
    },
  };
</script>

<style scoped>
  .overview-message-radiograph-link-button {
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    color: #1976d2;
    text-decoration: underline;
    cursor: pointer;
    font: inherit;
    line-height: inherit;
  }
</style>
